module.exports = __webpack_public_path__ + "static/media/addLogEntry.b3e9801c.png";